import { render, staticRenderFns } from "./CustomRole.vue?vue&type=template&id=f5ee8402&scoped=true&"
import script from "./CustomRole.vue?vue&type=script&lang=js&"
export * from "./CustomRole.vue?vue&type=script&lang=js&"
import style0 from "./CustomRole.vue?vue&type=style&index=0&id=f5ee8402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ee8402",
  null
  
)

export default component.exports